import { Platform } from '@angular/cdk/platform';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { EventTypes, ListProperty } from '@site-mate/dashpivot-shared-library';

import { OrthogonalDirection } from 'app/shared/model/orthogonal-direction.enum';
import { EventsService } from 'app/shared/service/events/events.service';
import { DropdownComponent } from 'app/ui-components/dropdown/dropdown.component';

import { ListPropertyColumnMovedEvent } from './list-property-column-moved.interface';

@Component({
  templateUrl: './list-header-edit.component.html',
  styleUrls: ['./list-header-edit.component.scss'],
  selector: 'cc-list-header-edit',
})
export class ListHeaderEditComponent {
  @Input() index: number;
  @Input() isLast: boolean;
  @Input() property: Partial<ListProperty>;
  @Input() editable = true;
  @Input() isUpgradeModalVisible: boolean;
  @Input() hasReachedPlanLimit: boolean;
  @Output() readonly setName = new EventEmitter<Partial<ListProperty>>();
  @Output() readonly onPropertyDeleted = new EventEmitter<void>();
  @Output() readonly onPropertyMoved = new EventEmitter<ListPropertyColumnMovedEvent>();
  @Output() readonly onRequestAddProperty = new EventEmitter<number>();

  @ViewChild('actionDropdown') actionDropdown: DropdownComponent;

  readonly directions = OrthogonalDirection;
  propertyName: string;

  constructor(private readonly eventsService: EventsService, private readonly platform: Platform) {}

  onPropertyNameChanged(newPropertyName: string) {
    this.propertyName = newPropertyName;
  }

  onUpdateName(newName: string) {
    const property = { ...this.property, name: newName };
    this.setName.emit(property);
  }

  onCancelEditName(input: HTMLInputElement) {
    input.value = this.property.name;
    input.blur();
  }

  requestAddProperty(direction: OrthogonalDirection) {
    const addIndex = direction === OrthogonalDirection.Left ? this.index : this.index + 1;
    this.onRequestAddProperty.emit(addIndex);
    this.eventsService.trackEvent(EventTypes.ListPropertyInsertInBetween, { Context: direction });
    this.actionDropdown.close();
  }

  onMouseEnter(target: HTMLInputElement) {
    if (!this.platform.FIREFOX) {
      target.style.textOverflow = 'clip';
      target.style.overflow = 'auto';
    }
  }

  onMouseLeave(target: HTMLInputElement) {
    if (!this.platform.FIREFOX) {
      target.style.textOverflow = 'ellipsis';
      target.style.overflow = 'hidden';
      target.scrollLeft = 0;
    }
  }
}
